export default "__VITE_ASSET__CnuqKFxD__"